import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import memoize from '@github/memoize/decorator';
import { Company } from '@macs-frontend/web-macs/shared';
import * as accounting from 'accounting-js';
import { Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { CurrentCompanyService, defaultNumberFormat } from '../../../core';

@Pipe({ name: 'mdNumber', pure: false })
export class CompanyNumberPipe implements PipeTransform, OnDestroy {
  destroy$: Subject<any> = new Subject();
  numberFormat = defaultNumberFormat;
  // @ts-expect-error
  thousand: string;
  // @ts-expect-error
  decimal: string;

  constructor(
    private currentCompanyService: CurrentCompanyService,
    private cdr: ChangeDetectorRef,
  ) {
    this.currentCompanyService.currentCompany$
      .pipe(
        takeUntil(this.destroy$),
        filter(company => !!company),
        tap((company: Company) => {
          this.numberFormat = company.numberFormat
            ? company.numberFormat
            : this.numberFormat;
          this.setConfiguration();
          this.cdr.markForCheck();
        }),
      )
      .subscribe();

    this.setConfiguration();
  }

  setConfiguration() {
    this.thousand = this.numberFormat.charAt(1);
    this.decimal = this.numberFormat.charAt(5);
  }

  @memoize()
  transform(value: any, precision = 2): string {
    return accounting.formatNumber(value || 0, {
      precision,
      thousand: this.thousand,
      decimal: this.decimal,
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
